import React, { Component } from 'react'
import StagesManager from '../../components/StagesManager';
import FileUserViewList from './FileUserViewList';
import FileUserViewSingle from './FileUserViewSingle';
// import DirectoryViewer from './DirectoryViewer';

export default class FileUserView extends Component {

    state = {}

    changeStage = (stage) => {
        this.stageManager.changeStage(stage)
    }

    render() {
        return (
            <div className='w-100 d-flex window-content-radius h-100'>
                <StagesManager height={'100%'} ref={el => this.stageManager = el} fast={true}>
                    {/* <DirectoryViewer colors={this.props.colors} width={this.props.width} filteredFiles={[this.props.driveInfo]} view={'details'} changeStage={this.changeStage} stage={0} stageName={'list'} /> */}
                    <FileUserViewList baseUrl={this.props.baseUrl} windowData={this.props.windowData} changePage={this.props.changePage} page={this.props.page} getFiles={this.props.getFiles} colors={this.props.colors} changeStage={this.changeStage} setHeader={this.props.setHeader} width={this.props.width} driveInfo={this.props.driveInfo} stage={0} stageName={'list'} />
                    <FileUserViewSingle baseUrl={this.props.baseUrl} windowData={this.props.windowData} changePage={this.props.changePage} page={this.props.page} colors={this.props.colors} setHeader={this.props.setHeader} width={this.props.width} driveInfo={this.props.driveInfo} changeStage={this.changeStage} stage={1} stageName={'single'} />
                </StagesManager>
            </div>
        )
    }
}
